const debug = false;

import axios from "axios";
import { CreateStorageProxy } from "./LocalStorage";

const REFRESH_LIFETIME = 24 * 3600 * 1000; // 24h

class HookManager {
  #mHandlers;

  constructor() {
    this.#mHandlers = {};
  }

  on(eventName, callback) {
    if (typeof eventName === "string" && eventName.length > 0) {
      this.#mHandlers[eventName] = callback;
    }
  }

  trigger(eventName) {
    //console.log(eventName, this.#mHandlers);
    const handler = this.#mHandlers[eventName];
    if (handler) handler();
  }
}

const hookManager = new HookManager();
const instance = axios.create({
  baseURL: debug ? "http://localhost:8000/" : "https://api.rgpu.pro/",
  timeout: 5000,
  //headers: { "X-Custom-Header": "foobar" },
});

const storage = new CreateStorageProxy("auth", "0.0.1");

function redirect() {
  hookManager.trigger("wrong_creds");
  return Promise.reject({ detail: "processed_by_hook" });
}

function perform(method, uri, doAuth = false, data = undefined) {
  function _doRequest(resolve, reject, allowRefresh) {
    if (debug) console.log(`perform ${method} ${uri}`);
    if (doAuth && storage.jwt_access === undefined) {
      return redirect();
    }

    const config = doAuth ? { headers: { Authorization: `Bearer ${storage.jwt_access}` } } : undefined;

    function execute(method, uri, config, data) {
      if (method.toLowerCase() === "post") return instance.post(uri, data, config);
      if (method.toLowerCase() === "get") return instance.get(uri, config);
    }

    execute(method, uri, config, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        if (doAuth && allowRefresh && e.response && e.response.data && e.response.data.code === "token_not_valid") {
          refreshToken()
            .then(() => {
              _doRequest(resolve, reject, false);
            })
            .catch(reject);
        } else {
          if (e.response && e.response.data && e.response.data.detail) {
            if (debug) console.log(e.response);
            if (e.response.data.code && e.response.data.code == "user_inactive") {
              logout();
              return redirect();
            } else {
              reject({ detail: e.response.data.detail });
            }
          } else if (e.response && e.response.status) {
            reject({ detail: `network_error_${e.response.status}` });
          } else {
            reject({ detail: "network_error" });
          }
        }
      });
  }

  const promise = new Promise(function(resolve, reject) {
    _doRequest(resolve, reject, true);
  });

  return promise;
}

function ping() {
  // return perform("get", "ping/", true).catch(() => {
  // 	logout();
  // 	return redirect();
  // });
  return perform("get", "ping/", true);
}

function get_username() {
  return storage.logged_in_username;
}
export { get_username };

function login(username, password) {
  return perform("post", "api/token/", false, { username: username, password: password }).then((response) => {
    storage.jwt_access = response.access;
    storage.jwt_refresh = response.refresh;
    storage.logged_in_username = username;
    storage.jwt_expireAt = Date.now() + REFRESH_LIFETIME;

    setTimeout(() => {
      hookManager.trigger("login");
    }, 0);

    return Promise.resolve();
  });
}

function request_token(mode, username) {
  return perform("post", `requesttoken/${mode}/`, false, { username: username }).then((response) => {
    return Promise.resolve(response);
  });
}

function request_signup_token(username) {
  return request_token("signup", username);
}
export { request_signup_token };

function request_password_token(username) {
  return request_token("password", username);
}
export { request_password_token };

function check_token(username, token) {
  return perform("post", "checktoken/", false, { username: username, token: token }).then((response) => {
    return Promise.resolve(response);
  });
}

function reset_password(username, password, token) {
  const data = {
    username: username,
    password: password,
    token: token,
  };

  return perform("post", "resetpassword/", false, data).then(() => {
    return login(username, password);
    //return Promise.resolve();
  });
}

function order_server(server, phone) {
  return perform("post", "orderserver/", true, { server: server, phone: phone }).then(() => {
    return Promise.resolve();
  });
}

function validate_email(email) {
  return perform("post", "validateemail/", false, { email: email }).then(() => {
    return Promise.resolve();
  });
}
export { validate_email };

function get_documents() {
  return perform("get", "documents/", false).then((r) => {
    return Promise.resolve(r);
  });
}
export { get_documents };

function get_servers() {
  return perform("get", "servers/", false).then((r) => {
    return Promise.resolve(r);
  });
}
export { get_servers };

function logout() {
  delete storage.jwt_access;
  delete storage.jwt_refresh;
  delete storage.jwt_expireAt;
  delete storage.logged_in_username;

  setTimeout(() => {
    hookManager.trigger("logout");
  }, 0);
  return Promise.resolve();
}

function refreshToken() {
  if (storage.jwt_refresh === undefined) {
    return redirect();
  }

  return perform("post", "api/token/refresh/", false, { refresh: storage.jwt_refresh })
    .then((response) => {
      storage.jwt_access = response.access;
      return Promise.resolve();
    })
    .catch(() => {
      logout();
      return redirect();
    });
}

function isAuthenticated() {
  return storage.jwt_refresh != undefined && Date.now() < storage.jwt_expireAt;
}

export { ping, login, logout, check_token, reset_password, isAuthenticated, order_server };
export default hookManager;
